import { useMemo } from 'react';
import { FilterButtons } from 'app/agriculture/infobox/common/FilterButtons/FilterButtons';
import { AssetIcon } from 'app/agriculture/icons/components';
import { useNotes } from 'app/agriculture/queries/notes/useNotes';
import { useGenericEntityFromId } from 'app/agriculture/queries/entities/useGenericEntityFromId';
import { Entity } from 'app/agriculture/queries/entities/types/Entity';
import { Note } from 'app/agriculture/queries/notes/types/Note';

interface NoteButtonFiltersProps {
    filterIds: string[];
    onFilterIdsChange: (filterIds: string[]) => void;
}

export function NoteButtonFilters({ filterIds, onFilterIdsChange }: NoteButtonFiltersProps) {
    const notes = useNotes();
    const getParent = useGenericEntityFromId();

    const notesByParentType = useMemo(() => {
        const map = new Map<Entity['type'] | 'The Farm', Note[]>();
        for (const note of notes.values()) {
            const { type = 'The Farm' } = getParent(note.parentId) ?? {};
            map.set(type, [...(map.get(type) ?? []), note]);
        }
        return map;
    }, [notes, getParent]);

    const items = useMemo(
        () =>
            [...notesByParentType.keys()].map((name) => ({
                name,
                id: name,
                priority: ASSET_TYPE_PRIORITY[name],
                icon: name === 'The Farm' ? undefined : <AssetIcon name={name} size={18} />,
            })),
        [notesByParentType],
    );

    return (
        <FilterButtons
            orderBy="both"
            showMoreLimit={3}
            items={items}
            filterIds={filterIds}
            onChange={onFilterIdsChange}
        />
    );
}

const ASSET_TYPE_PRIORITY: Record<string, number> = {
    'The Farm': 1,
    Paddock: 2,
    Fence: 3,
};
